/**
 * @file Automatically generated by barrelsby.
 */

export * from './ProductDescription';
export * from './ProductDescriptionGroup';
export * from './TranslateTrigger';
